import { useState, useEffect } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";

export const useModalCodigos = () => {
  const [codigoPropuesta, setCodigoPropuesta] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [nuevoCodigo, setNuevoCodigo] = useState("");
  const [nuevoCodigoPropuesta, setNuevoCodigoPropuesta] = useState("");

  const actualizarCodigo = async () => {
    if (codigoPropuesta && numeroDocumento) {
      let endCode = await apiParticipantes.buscarCodigoFin(codigoPropuesta, numeroDocumento)
      setNuevoCodigo(endCode.data.nuevoCodigo)
    }
  };

  const actualizarCodigoNuevo = async () => {
    if (codigoPropuesta && numeroDocumento && nuevoCodigoPropuesta) {
      let endCode = await apiParticipantes.actualizarCodigo(codigoPropuesta, numeroDocumento, nuevoCodigoPropuesta)
      setNuevoCodigo(endCode.data.nuevoCodigo)
    }
  };

  useEffect(() => {
  }, [nuevoCodigo]);

  return {
    actualizarCodigo,
    setCodigoPropuesta,
    codigoPropuesta,
    numeroDocumento,
    setNumeroDocumento,
    nuevoCodigo,
    setNuevoCodigo,
    setNuevoCodigoPropuesta,
    nuevoCodigoPropuesta,
    actualizarCodigoNuevo
  };
};
